module.exports = __webpack_public_path__ + "img/Cabbio 2.9ea06a47.png";